import { render } from "./CombatLogBars.vue?vue&type=template&id=d4d5b21e"
import script from "./CombatLogBars.vue?vue&type=script&lang=js"
export * from "./CombatLogBars.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__